<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row form-group">
          <div class="col-md-12 d-flex align-items-center">
            <img
              :src="info.profile"
              alt
              :style="{ width: '50px', height: '50px' }"
            />
            <div class="ml-3 ts-float-left">
              <h1 class="ts-text-base">{{ info.name }}</h1>
              <h2 class="ts-text-base">
                <small>{{ info.gender }}</small>
              </h2>
            </div>
          </div>
        </div>
        <div class="row form-group" v-if="student.student_comments">
          <div class="col-md-12">
            <span class="badge badge-warning mb-2">
              {{ $t('homework.comment') }}
            </span>
            <div
              class="ts-p-3 ts-border ts-border-gray-300 ts-rounded ts-border-dashed"
            >
              <p>{{ student.student_comments }}</p>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <p class="badge badge-info">{{ $t('homework.answer') }}</p>
            <div class="ts-p-3">
              <ul>
                <li
                  v-for="(answer, index) in student_answer"
                  class="ts-float-left ts-px-2"
                  :key="index"
                >
                  <a
                    href="#"
                    v-tooltip="answer.original_file_name"
                    @click.prevent="onDownload(answer)"
                  >
                    <a-icon
                      type="file"
                      :style="{ fontSize: '16px', color: '#08c' }"
                      :spin="answer.action"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <drag-drop-upload v-model="files" :student="student" />
        <div class="validate ts-text-xs" v-if="errors.has('file_list')">
          {{ errors.first('file_list') }}
        </div>
        <div class="row form-group">
          <div class="col-md-4">
            <input
              type="number"
              v-model.number="model.score"
              step="any"
              class="form-control"
              :placeholder="$t('homework.score')"
            />
          </div>
          <div class="col-md-8">
            <input
              v-model.trim="model.teacher_comment"
              type="text"
              class="form-control"
              :placeholder="$t('homework.comment')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button
              color="primary"
              :waiting="waiting"
              @click.prevent="onSave"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import * as FileDownload from 'downloadjs'
import DragDropUpload from './drag-drop-upload-file'
import { Errors } from 'form-backend-validation'

export default {
  name: 'HomeworkworkSheetForm',
  props: ['student'],
  components: {
    DragDropUpload
  },
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      info: {
        name: 'Unknow',
        gender: null,
        profile: require('../../../../../assets/staff-default-man.png')
      },
      student_answer: [],
      files: {
        list: []
      },
      model: {
        homework_id: null,
        student_id: null,
        teacher_id: null,
        teacher_comment: null,
        score: null,
        student_homework_id: null,
        file_list: []
      },
      correcting_student_id: 0
    }
  },
  computed: {},
  methods: {
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('eschool/homeworkCorrection/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$parent.fetchHomewrok()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onDownload(record) {
      record.action = true
      this.$store
        .dispatch('eschool/homeworkCorrection/download', {
          filePath: record.file_path.split('filePath=').pop()
        })
        .then(response => {
          FileDownload(response, record.original_file_name, record.mime_type)
        })
        .catch(error => {
          let parese_error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(error))
          )
          this.$toasted.error(parese_error.message)
        })
        .finally(() => {
          record.action = false
        })
    },
    setData() {
      // set file of student has been answer this homework
      this.student_answer = [
        ...this.student.student_answer.filter(f => f.attach_type_id == 3)
      ]

      // set student info to display
      this.info = {
        name: this.student.student.full_name_en,
        gender: this.student.student.gender,
        profile: this.student.student.photo
      }

      // list file in drag and drop zone
      this.files.list = [
        ...this.files.list,
        ..._.map(
          this.student.student_answer.filter(f => f.attach_type_id == 4),
          file => ({
            name: file.original_file_name,
            size: 0,
            type: file.mime_type,
            progressing: 100,
            invalid_file: false,
            file: null,
            uploaded: true,
            storage_path: file.file_path
          })
        )
      ]

      // set data that which send to server update or create
      this.model.homework_id = this.student.homework_id
      this.model.student_id = this.student.student_id
      this.model.teacher_id = this.student.teacher_id
      this.model.student_homework_id = this.student.student_homework_id
      this.model.teacher_comment = this.student.teacher_comment
      this.model.score = this.student.score
      this.model.file_list = _.map(
        this.student.student_answer.filter(f => f.attach_type_id == 4),
        file => ({
          attach_file_name: file.original_file_name,
          attach_file_path: file.file_path,
          mime_type: file.mime_type,
          file_type: 4,
          new_file: false,
          is_delete: false
        })
      )
    },
    clearInput() {
      ;(this.info.name = 'Unknow'),
        (this.info.gender = null),
        (this.info.profile = require('../../../../../assets/staff-default-man.png'))

      this.student_answer = []
      this.files.list = []
      this.$children[0].$refs.input_submit_file.value = null

      this.model.homework_id = null
      this.model.student_id = null
      this.model.teacher_id = null
      this.model.teacher_comment = null
      this.model.score = null
      this.model.student_homework_id = 0
      this.model.file_list = []
      this.correcting_student_id = 0
    }
  },
  watch: {
    student: {
      handler(value) {
        this.clearInput()
        if (value) {
          if (value.student_homework_id == this.correcting_student_id) return
          this.correcting_student_id = value.student_homework_id
          this.setData()
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="css" scoped>
img {
  float: left;
  border-radius: 103px;
  padding: 3px;
  object-fit: cover;
  object-position: center;
  background: #fff7f7;
}
</style>
